import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/App';

const isProd = process.env.NODE_ENV === 'production';

class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorId: null };
  }

  static getDerivedStateFromError(error) {
    return {
      error,
      errorId: `ui_${Date.now().toString(36)}`,
    };
  }

  componentDidCatch(error, info) {
    console.error('App crashed', this.state.errorId, error, info);
  }

  render() {
    if (this.state.error) {
      const detail = isProd
        ? 'Something went wrong loading the dashboard. Try refreshing. If it continues, contact support@logisticslash.com and mention the error ID.'
        : String(this.state.error?.stack || this.state.error?.message || this.state.error);
      return (
        <div style={{ padding: 24, fontFamily: 'system-ui', maxWidth: 640 }}>
          <h1 style={{ color: '#b91c1c' }}>UI failed to load</h1>
          {this.state.errorId ? (
            <p style={{ color: '#64748b', fontSize: 14 }}>Error ID: {this.state.errorId}</p>
          ) : null}
          <pre style={{ whiteSpace: 'pre-wrap', background: '#f8fafc', padding: 12 }}>{detail}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const el = document.getElementById('root');
const root = ReactDOM.createRoot(el);
root.render(
  <React.StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </React.StrictMode>
);
